import { isNullOrEmpty } from 'src/util/string';
/* eslint-disable */
export interface IntercomConfiguration {
  enabled: boolean;
  appId: string | null;
}

export function bootstrapIntercom({ enabled, appId }: IntercomConfiguration) {
  if (!enabled) return;

  if (isNullOrEmpty(appId)) {
    console.warn('Intercom is enabled but app id was not provided.');
    return;
  }

  (function (w, d) {
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var i = <any>function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args: any) {
        i.q.push(args);
      };
      w.Intercom = i;
      const l = () => {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/f4dfxj6e';
        var x = d.getElementsByTagName('script')[0];
        x.parentNode!.insertBefore(s, x);
      };
      if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  })(window as any, document as Document);
}
